import { render, staticRenderFns } from "./RevViewBackButton.vue?vue&type=template&id=6f0afc6c"
import script from "./RevViewBackButton.vue?vue&type=script&lang=js"
export * from "./RevViewBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports